import { useRef } from 'react';
import { categories, categoryImages } from '@/mocks/categories';

export default function CategoryScroll() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const amount = 320;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -amount : amount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section className="relative w-full py-20 md:py-28 px-4 md:px-6 bg-foreground-950 overflow-hidden">
      <div className="max-w-6xl mx-auto mb-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div>
            <span className="inline-block px-3 py-1 rounded-full border border-background-50/20 text-background-50 font-label text-xs font-medium mb-4 whitespace-nowrap">
              Wszystkie Kategorie
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight">
              14 Kategorii Produktów
            </h2>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={() => scroll('left')}
              className="w-10 h-10 rounded-full border border-background-50/20 flex items-center justify-center text-background-50 hover:bg-background-50/10 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              className="w-10 h-10 rounded-full border border-background-50/20 flex items-center justify-center text-background-50 hover:bg-background-50/10 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>

      <div
        ref={scrollRef}
        className="flex gap-4 overflow-x-auto px-4 md:px-6 scrollbar-hide pb-4"
        style={{ scrollSnapType: 'x mandatory', msOverflowStyle: 'none', scrollbarWidth: 'none' }}
      >
        {categories.map((cat, i) => (
          <a
            key={cat.slug}
            href={cat.url}
            target="_blank"
            rel="noopener nofollow"
            className="flex-shrink-0 w-[240px] md:w-[260px] rounded-2xl overflow-hidden group cursor-pointer snap-start"
            style={{ scrollSnapAlign: 'start' }}
          >
            <div className="relative w-full aspect-square bg-background-100 rounded-xl overflow-hidden mb-3">
              <img
                src={categoryImages[i]}
                alt={cat.name}
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="px-1">
              <h4 className="font-label text-sm font-semibold text-background-50 mb-1">{cat.name}</h4>
              <span className="font-body text-xs text-background-50/60 flex items-center gap-1">
                Przejdź <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}